import {ParametrizarValorFleteService} from '../../services/parametrizar-valor-flete.service';
import {UtilsService} from '../../../../shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from '../../../../shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AfterViewInit, Component, OnInit} from '@angular/core';
import {moduloGaritas} from '../../diccionarios/balanzaModulo.js';
import {IValorFleteResponse} from '../../modelos/IValorFlete';
import {formatDate} from '@angular/common';
import {MantenimientoOrigenesExtractorasService} from '../../services/mantenimiento-origenes-extractoras.service';
import { ProveedorService } from '../../services/proveedor.service';


@Component({
  selector: 'app-parametrizar-valor-flete',
  templateUrl: './parametrizar-valor-flete.component.html',
  styleUrls: ['./parametrizar-valor-flete.component.scss'],
})
export class ParametrizarValorFleteComponent implements OnInit, AfterViewInit {
  public loading: boolean = false;

  public DAT_TITULOS: any = moduloGaritas.titulos.parametrizarValorFlete;
  public DAT_BTNS: any = moduloGaritas.button.buttonsNombre;
  public DAT_BTNCSS: any = moduloGaritas.button.buttonsCss;
  public DAT_MSG: any = moduloGaritas.mensajes;

  public DAT_AG_GRID: any = moduloGaritas.agGrid;

  public columnDefs: any[] = [];
  public rowData: IValorFleteResponse[] = [];
  public gridApi: any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public tituloModal: string;
  public isCreate: boolean = true;
  public valorFlete: IValorFleteResponse;
  public dateValidate = false;
  public dateValidateData;
  public dateNotLessCurrent = false;
  public proveedorInvalido = true;
  public origenInvalido = true;
  public materialInvalido = true;

  public agregarValorFlete = new FormGroup({
    id: new FormControl('', []),
    provee: new FormControl('', Validators.required),
    despro: new FormControl('', Validators.required),
    codori: new FormControl('', Validators.required),
    desori: new FormControl('', Validators.required),
    mat: new FormControl('', Validators.required),
    desmat: new FormControl('', Validators.required),
    fechaini: new FormControl('', Validators.required),
    fechafin: new FormControl('', Validators.required),
    precio: new FormControl('', [Validators.required, Validators.pattern(/^(?!0\d|$)\d*(\.\d{1,4})?$/)]),
  });
  proveedor = "";

  constructor(
    private _util: UtilsService,
    private parametrizarValorFleteService: ParametrizarValorFleteService,
    private MantenimientoOrigenesExtractorasService: MantenimientoOrigenesExtractorasService,
    private proveedorS: ProveedorService,
  ) {
  }

  get idControl() {
    return this.agregarValorFlete.get('id');
  }

  get proveeControl() {
    return this.agregarValorFlete.get('provee');
  }

  get desproControl() {
    return this.agregarValorFlete.get('despro');
  }

  get cod_origenControl() {
    return this.agregarValorFlete.get('codori');
  }

  get desoriControl() {
    return this.agregarValorFlete.get('desori');
  }

  get materialControl() {
    return this.agregarValorFlete.get('mat');
  }

  get desmatControl() {
    return this.agregarValorFlete.get('desmat');
  }

  get fecha_iniControl() {
    return this.agregarValorFlete.get('fechaini');
  }

  get fecha_finControl() {
    return this.agregarValorFlete.get('fechafin');
  }

  get precioControl() {
    return this.agregarValorFlete.get('precio');
  }

  girdComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: 'Proveedor',
        field: 'provee',
        sortable: true,
        filter: true,
        width: 120,
        sort: "asc"
      },
      {
        headerName: 'Descrip.Proveedor',
        field: 'despro',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Origen',
        field: 'codori',
        sortable: true,
        filter: true,
        width: 110,
      },
      {
        headerName: 'Descrip.Origen',
        field: 'desori',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Material',
        field: 'mat',
        sortable: true,
        filter: true,
        width: 120,
      },
      {
        headerName: 'Descripción Material',
        field: 'desmat',
        sortable: true,
        filter: true,
        //width: 200,
      },
      {
        headerName: 'Fecha Ini',
        field: 'fechaini',
        sortable: true,
        filter: true,
        width: 120,
      },
      {
        headerName: 'Fecha Fin',
        field: 'fechafin',
        sortable: true,
        filter: true,
        width: 120,
      },
      {
        headerName: 'Precio',
        field: 'precio',
        sortable: true,
        filter: true,
        width: 100,
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        //width: 80,
        cellRendererParams: {
          onClick: this.editarValorFlete.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        //width: 90,
        cellRendererParams: {
          onClick: this.eliminarValorFlete.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger,
        }
      }
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

    //params.api.sizeColumnsToFit();
  }

  ngOnInit(): void {
    this.agregarValorFlete.get('idGarita')?.disable({onlySelf: true});
    this.girdComponent();
    this.obtenerOrigenesExtractoras();
  }

  ngAfterViewInit() {
    this.obtenerValorFlete();
  }

  obtenerValorFlete() {
    this.loading = true;
    this.parametrizarValorFleteService.obtener().subscribe(
      (resp) => {
        this.rowData = resp.map(e => {
          e['fechaini'] = e['fechaini'].split("T")[0].split("-").reverse().join('-');
          e['fechafin'] = e['fechafin'].split("T")[0].split("-").reverse().join('-');
          return e;
        });
        this.loading = false;
      },
      (error) => {
        this.rowData = [];
        this.loading = false;
      }
    );
  }

  guardarEditarValorFlete() {
    this.loading = true;
    if (this.agregarValorFlete.invalid) return;
    this.valorFlete = this.agregarValorFlete.getRawValue();
    this.valorFlete.fechaini = new Date(this.fecha_iniControl.value).toISOString().split(".")[0];
    this.valorFlete.fechafin = new Date(this.fecha_finControl.value).toISOString().split(".")[0];
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.actualizar,
        // text: `${this.valorFlete.cod_origen}`,
        action: this.DAT_BTNS.editar,
        funcion: this.parametrizarValorFleteService.actualizar(this.valorFlete),
      })
      .then(() => {
        this.obtenerValorFlete();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  guardarCrearNuevNuevoValorFlete() {
    this.loading = true;
    if (this.agregarValorFlete.invalid) return;
    this.valorFlete = this.agregarValorFlete.getRawValue();
    // this.valorFlete.fechaini = new Date().toISOString().split(".")[0];
    this.valorFlete.fechaini = new Date(this.fecha_iniControl.value).toISOString().split(".")[0];
    this.valorFlete.fechafin = new Date(this.fecha_finControl.value).toISOString().split(".")[0];
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.procesar,
        // text: `Garita: ${this.valorFlete.cod_origen}`,
        action: this.DAT_BTNS.nuevo,
        funcion: this.parametrizarValorFleteService.crear(this.valorFlete),
      })
      .then(() => {
        this.obtenerValorFlete();
        this.loading = false;
        this.closeModal();
      })
      .catch(() => {
        this.loading = false;
      });
  }

  eliminarValorFlete({rowData}) {
    this.loading = true;
    this._util
      .confirmarSincronoPromesa({
        title: this.DAT_MSG.eliminar,
        // text: `${rowData.idValorFlete}`,
        action: this.DAT_BTNS.eliminar,
        funcion: this.parametrizarValorFleteService.borrar(rowData.id),
      })
      .then((res: any) => {
        this.obtenerValorFlete();
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  nuevoValorFlete() {
    this.isCreate = true;
    this.dateValidate = false;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    this.agregarValorFlete.reset();
    this.agregarValorFlete.controls['fechaini'].setValue(
      formatDate(new Date(), 'yyyy-MM-dd', 'en')
    );
    this.agregarValorFlete.controls['fechafin'].setValue(
      formatDate(new Date(), 'yyyy-MM-dd', 'en')
    );
    this.openModal();
  }

  editarValorFlete({rowData}) {
    this.isCreate = false;
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;
    this.agregarValorFlete.patchValue(rowData);
    this.agregarValorFlete.controls['fechaini'].setValue(rowData.fechaini.split("-").reverse().join('-'));
    this.agregarValorFlete.controls['fechafin'].setValue(rowData.fechafin.split("-").reverse().join('-'));
    this.onChangeProveedor('');
    this.onChangeMaterial('');
    this.onChangeCodOrigen('');
    this.onChangeValues();
    this.openModal();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();
    if (this.isCreate) this.guardarCrearNuevNuevoValorFlete();
    if (!this.isCreate) this.guardarEditarValorFlete();
  }

  openModal() {
    document.getElementById('abrirModalAgregarValorFlete').click();
  }

  closeModal() {
    document.getElementById('cerrarModalAgregarGarita').click();
  }

  getDescProveedor(proveedor: string): any {
    console.log("proveedor", proveedor)
    let prov = "";
    if (this.proveeControl.value > 0) {
      this.parametrizarValorFleteService.getProveedor(proveedor).subscribe(
        (resp) => {
          if (resp) prov = resp.provNombre;
          prov = '';
        },
        (error) => {
          prov = '';
        }
      );
      return prov;
    }
  }

  onChangeProveedor(event: any) {
    console.log("onChangeProveedor", this.proveeControl.value)
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    if (this.proveeControl.value != null && this.proveeControl.value.length > 0) {
      this.proveedorS.obtenerPorId(this.proveeControl.value).subscribe(
        (resp) => {
          if (resp) {
            console.log("RESP obtenerPorId", resp)
            this.agregarValorFlete.controls['despro'].setValue(resp.nombre);
            this.proveedorInvalido = false;
          } else {
            this.agregarValorFlete.controls['despro'].setValue('');
            this.proveedorInvalido = true;
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.agregarValorFlete.controls['despro'].setValue('');
          this.proveedorInvalido = true;
        }
      );
      // this.parametrizarValorFleteService.getProveedor(this.proveeControl.value).subscribe(
      //   (resp) => {
      //     if (resp) {
      //       this.proveedorInvalido = false;
      //       this.agregarValorFlete.controls['despro'].setValue(resp.nombre);
      //     } else {
      //       this.proveedorInvalido = true;
      //       this.agregarValorFlete.controls['despro'].setValue('');
      //     }
      //     this.onChangeValues();
      //     this.loading = false;
      //   },
      //   (error) => {
      //     this.onChangeValues();
      //     this.loading = false;
      //     this.proveedorInvalido = true;
      //     this.agregarValorFlete.controls['despro'].setValue('');
      //   }
      // );
    }
  }

  getDescCodOrigen(origen: string): any {
    this.parametrizarValorFleteService.getAlmacen(origen).subscribe(
      (resp) => {
        if (resp) return resp.descripcion;
        else return '';
      },
      (error) => {
        return '';
      }
    );
  }

  onChangeCodOrigen(event: any) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    if (this.cod_origenControl.value != null && this.cod_origenControl.value.length > 0) {
      this.MantenimientoOrigenesExtractorasService.obtenerPorId(this.cod_origenControl.value).subscribe(
        (resp) => {
          if (resp) {
            this.origenInvalido = false;
            this.agregarValorFlete.controls['desori'].setValue(resp.descripcion);
            this.agregarValorFlete.controls['provee'].setValue(resp.proveedor);
            this.onChangeProveedor(event);

          } else {
            this.origenInvalido = true;
            this.agregarValorFlete.controls['desori'].setValue('');
            this.agregarValorFlete.controls['provee'].setValue('');
          }
          this.onChangeValues();
          this.loading = false;
        },
        (error) => {
          this.onChangeValues();
          this.loading = false;
          this.origenInvalido = true;
          this.agregarValorFlete.controls['desori'].setValue('');
          this.agregarValorFlete.controls['provee'].setValue('');
        }
      );
    }
  }

  getDescMaterial(material: string): any {
    this.parametrizarValorFleteService.getProveedor(material).subscribe(
      (resp) => {
        if (resp) return resp.descripcion;
        else return '';
      },
      (error) => {
        return '';
      }
    );
  }

  onChangeMaterial(event: any) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    this.loading = true;
    this.parametrizarValorFleteService.getMaterial(this.materialControl.value).subscribe(
      (resp) => {
        if (resp) {
          this.materialInvalido = false;
          this.agregarValorFlete.controls['desmat'].setValue(resp.idMaterial + " - " + resp.dscaMaterial);
        } else {
          this.materialInvalido = true;
          this.agregarValorFlete.controls['desmat'].setValue('');
        }
        this.onChangeValues();
        this.loading = false;
      },
      (error) => {
        this.onChangeValues();
        this.loading = false;
        this.materialInvalido = true;
        this.agregarValorFlete.controls['desmat'].setValue('');
      }
    );
  }

  onChangeValues() {
    console.log("onChangeValues")
    this.dateValidate = false;
    this.dateNotLessCurrent = false;

    if (this.agregarValorFlete.controls['fechafin'].value.length > 0 && this.agregarValorFlete.controls['fechafin'].value.length > 0) {
      if (this.agregarValorFlete.controls['fechafin'].value < this.agregarValorFlete.controls['fechaini'].value) {
        this.dateNotLessCurrent = true;
      } else {
        this.dateNotLessCurrent = false;
      }
    }

    if (
      this.agregarValorFlete.controls['provee'].value != null &&
      this.agregarValorFlete.controls['codori'].value != null &&
      this.agregarValorFlete.controls['mat'].value != null &&
      this.agregarValorFlete.controls['fechaini'].value != null &&
      this.agregarValorFlete.controls['fechafin'].value != null &&

      this.agregarValorFlete.controls['provee'].value.length > 0 &&
      this.agregarValorFlete.controls['codori'].value.length > 0 &&
      this.agregarValorFlete.controls['mat'].value.length > 0 &&
      this.agregarValorFlete.controls['fechaini'].value.length > 0 &&
      this.agregarValorFlete.controls['fechafin'].value.length > 0 &&
      !this.dateNotLessCurrent
    ) {
      this.validateRangeDates()
    }

  }

  validForm() {
    return (
      this.proveedorInvalido == false &&
      this.origenInvalido == false &&
      this.materialInvalido == false &&
      this.agregarValorFlete.invalid == false &&
      this.dateValidate == false &&
      this.dateNotLessCurrent == false) ? false : true;
  }

  keyDecimals(event: KeyboardEvent) {
    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

    return true;
  }

  noWhitespace(event: KeyboardEvent) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32)
      return false;

    return true;
  }

  validateRangeDates() {

    let day;
    let month;
    let year;
    let dateStart;
    let dateEnd;
    let dateSplit;
    let datesToValidate = [];
    let datesRange = [];

    dateStart = this.agregarValorFlete.controls['fechaini'].value;
    dateEnd = this.agregarValorFlete.controls['fechafin'].value;
    dateSplit = dateStart.split("-");

    day = parseInt(dateSplit[2]);
    month = parseInt(dateSplit[1]);
    year = parseInt(dateSplit[0]);

    while (dateStart <= dateEnd) {

      datesRange.push(dateStart);
      day = day + 1;

      if (day >= 31) {
        day = 1;
        month = month + 1;
      }
      if (month >= 13) {
        month = 1;
        year = year + 1;
      }

      dateStart = year.toString().padStart(2, "0") + "-" + month.toString().padStart(2, "0") + "-" + day.toString().padStart(2, "0");

    }

    for (let i = 0; i < this.rowData.length; i++) {

      if (this.rowData[i].id == this.agregarValorFlete.controls['id'].value) continue;

      dateStart = this.rowData[i].fechaini.split("T")[0].split("-").reverse().join('-');
      dateEnd = this.rowData[i].fechafin.split("T")[0].split("-").reverse().join('-');
      dateSplit = dateStart.split("-");

      day = parseInt(dateSplit[2]);
      month = parseInt(dateSplit[1]);
      year = parseInt(dateSplit[0]);

      while (dateStart <= dateEnd) {

        console.log("WHILE", dateStart, "<=", dateEnd)

        datesToValidate.push(dateStart + "|" + this.rowData[i].id);

        day = day + 1;

        if (day >= 31) {
          day = 1;
          month = month + 1;
        }
        if (month >= 13) {
          month = 1;
          year = year + 1;
        }

        dateStart = year.toString().padStart(2, "0") + "-" + month.toString().padStart(2, "0") + "-" + day.toString().padStart(2, "0");

      }
    }

    for (let i = 0; i < datesRange.length; i++) {
      if (datesToValidate.find((x => x.split("|")[0] === datesRange[i]))) {
        this.dateValidateData = this.rowData.find(x => x.id == datesToValidate.find((element) => {
          if (element.split("|")[0] === datesRange[i]) {
            return element.split("|")[1];
          }
        }).split("|")[1]);

        if (
          this.agregarValorFlete.controls['provee'].value == this.dateValidateData.provee &&
          this.agregarValorFlete.controls['codori'].value == this.dateValidateData.codori &&
          this.agregarValorFlete.controls['mat'].value == this.dateValidateData.mat
        ) {
          this.dateValidate = true;
          break;
        } else
          ;

      }
    }

  }

  origenesExtractoras;
  obtenerOrigenesExtractoras() {
    this.loading = true;
    this.MantenimientoOrigenesExtractorasService.obtener().subscribe(
      (resp) => {
        console.log("obtenerOrigenesExtractoras", resp)
        this.origenesExtractoras = resp.filter(item => item["estado"] == "ACTIVO");
        this.loading = false;
      },
      (error) => {
        this.origenesExtractoras = [];
        this.loading = false;
      }
    )
  }



}
